import moment from 'moment';

// A blank end date means an ongoing group (MTC-173): the API receives null, never
// moment's 'Invalid date'.
export const formatEndDateForApi = (endDate) =>
	endDate ? moment(endDate).format('YYYY-MM-DD') : null;
